// Słownik kursu v2 do ekranów: znaczenie słowa z lekcji (cele i słowa dopisane w kroku 2) dla karty „jak to się czyta”.
import type { LessonV2 } from './levels.ts';

const clean = (w: string): string => w.trim().toLowerCase().replace(/[^\p{L}'-]/gu, '');

/** Tłumaczenie słowa z lekcji kursu (cel albo słowo dopisane); cele z ukośnikiem („ok/okay”) pasują do każdej formy. Brak = null. */
export function courseMeaning(lessons: readonly LessonV2[], word: string): string | null {
  const k = clean(word);
  if (!k) return null;
  for (const l of lessons) {
    for (const t of l.targets) if (t.word.toLowerCase().split('/').some((f) => f.trim() === k)) return t.pl;
    for (const e of l.enrich.extras) if (e.word.toLowerCase() === k) return e.pl;
  }
  return null;
}
